/**
 * SEO Utility for managing meta tags dynamically
 */

export const updateMetaTags = (metaData) => {
  // Update title
  if (metaData.title) {
    document.title = metaData.title;
  }

  // Helper function to update or create meta tag
  const updateMetaTag = (name, content, property = false) => {
    if (!content) return;
    
    const attribute = property ? 'property' : 'name';
    const selector = property ? `meta[property="${name}"]` : `meta[name="${name}"]`;
    
    let meta = document.querySelector(selector);
    if (meta) {
      meta.setAttribute('content', content);
    } else {
      meta = document.createElement('meta');
      meta.setAttribute(attribute, name);
      meta.setAttribute('content', content);
      document.head.appendChild(meta);
    }
  };

  // Update description
  updateMetaTag('description', metaData.description);
  
  // Update keywords
  updateMetaTag('keywords', metaData.keywords);
  
  // Update robots
  updateMetaTag('robots', metaData.robots || 'index, follow');

  // Update canonical URL
  if (metaData.canonical) {
    let canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', metaData.canonical);
    } else {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      canonical.setAttribute('href', metaData.canonical);
      document.head.appendChild(canonical);
    }
  }

  // Open Graph tags
  updateMetaTag('og:title', metaData.ogTitle || metaData.title, true);
  updateMetaTag('og:description', metaData.ogDescription || metaData.description, true);
  updateMetaTag('og:url', metaData.ogUrl || metaData.canonical, true);
  updateMetaTag('og:image', metaData.ogImage, true);
  updateMetaTag('og:type', metaData.ogType || 'website', true);
  updateMetaTag('og:site_name', 'Diginova', true);

  // Twitter tags
  updateMetaTag('twitter:card', metaData.twitterCard || 'summary_large_image', true);
  updateMetaTag('twitter:title', metaData.twitterTitle || metaData.title, true);
  updateMetaTag('twitter:description', metaData.twitterDescription || metaData.description, true);
  updateMetaTag('twitter:image', metaData.twitterImage || metaData.ogImage, true);
  updateMetaTag('twitter:url', metaData.twitterUrl || metaData.canonical, true);
};

export const defaultSEO = {
  title: 'Diginova - Digital Design & Web Development Agency | Swiss Excellence',
  description: 'Diginova is a Swiss digital agency specializing in branding, web design, and development. We create stunning digital experiences that blend creativity with functionality.',
  keywords: 'digital agency, web design, web development, branding, Swiss agency, UI/UX design, website creation, digital marketing, responsive design',
  canonical: 'https://diginova.ch/',
  ogImage: 'https://diginova.ch/assets/img/logo-250.jpg',
  robots: 'index, follow'
};